var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDownNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 12,
    viewBox: "0 0 22 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.292787 0.292787C0.480314 0.105316 0.734622 0 0.999786 0C1.26495 0 1.51926 0.105316 1.70679 0.292787L10.9998 9.58579L20.2928 0.292787C20.4814 0.110629 20.734 0.0098342 20.9962 0.0121126C21.2584 0.014391 21.5092 0.11956 21.6946 0.304968C21.88 0.490376 21.9852 0.741189 21.9875 1.00339C21.9897 1.26558 21.8889 1.51818 21.7068 1.70679L11.7068 11.7068C11.5193 11.8943 11.2649 11.9996 10.9998 11.9996C10.7346 11.9996 10.4803 11.8943 10.2928 11.7068L0.292787 1.70679C0.105316 1.51926 0 1.26495 0 0.999786C0 0.734622 0.105316 0.480314 0.292787 0.292787Z",
    fill: "#0F0E0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownNew);
export default __webpack_public_path__ + "static/media/arrowDownNew.559787c6e06a4d9348c27f0eaf052fca.svg";
export { ForwardRef as ReactComponent };